"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgNotificationSettings(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16.00024', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm3.93 11.00024a1.57 1.57 0 0 0 3.14 0zm3.41-.79h-7.34v-.78l1.57-1.57v-2.36a4 4 0 0 1 2.91-4.16v-.4a1 1 0 0 1 1.02-.94 1.09 1.09 0 0 1 1 .94v.4a4 4 0 0 1 2.93 4.16v2.23a5.08 5.08 0 0 0 -2.09 2.48zm8.66 2.50247v-1.42737l-1.101-.22211a3.03523 3.03523 0 0 0 -.18811-.45135l.621-.93488-1.009-1.00934-.93274.61987a3.01987 3.01987 0 0 0 -.45618-.19067l-.22052-1.09381h-1.42689l-.22046 1.09381a3.0184 3.0184 0 0 0 -.45862.19183l-.92877-.61724-1.009 1.00927.619.93195a3.026 3.026 0 0 0 -.19025.4574l-1.0932.22052v1.42741l1.09955.22181a3.0243 3.0243 0 0 0 .18951.45172l-.62085.93481 1.00891 1.00934.93982-.62457a3.02633 3.02633 0 0 0 .44715.18591l.22247 1.10327h1.42688l.22327-1.10742a3.02506 3.02506 0 0 0 .44421-.18585l.94037.62488 1.00891-1.00928-.625-.9411a3.03035 3.03035 0 0 0 .18634-.44623zm-4 .807a1.52341 1.52341 0 1 1 1.52289-1.52344 1.52317 1.52317 0 0 1 -1.52289 1.52344z' })));
}
exports.default = SvgNotificationSettings;
